<template>
	<div>
		<navigation-tab :tabs="tabs" />
		<router-view/>
	</div>
</template>

<script>
import NavigationTab from '@/components/navigation/NavigationTab'
export default {
	components: {
		NavigationTab
	},
	data() {
		return {
			tabs: [
				{ active: true, route: 'UserProfileAccount', title: this.$t('base.profile.information') },
				{ active: true, route: 'UserProfileAccountName', title: this.$t('base.profile.change_name') },
				{ active: true, route: 'UserProfileAccountEmail', title: this.$t('base.profile.change_email') },
				{ active: true, route: 'UserProfileAccountPassword', title: this.$t('base.profile.change_password') },
				{ active: true, route: 'UserProfileAccountPicture', title: this.$t('base.profile.change_picture') },
			]
		}
	},
	beforeRouteEnter (to, from, next) {
		next(vm => {
			vm.$title('Account Information')
		})
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/profile/AccountInformation.vue